export const __ENABLE_FAVICONS_PULL = false;
export const __MAX_NUMBER_ITEMS_BY_CARD = 12;
export const __MAX_NUMBER_ITEMS_RECENT_SEARCH = 5;
export const __FEEDBACK_FORM_URL = "https://forms.gle/aqejVkqdB9z2pE6k9";